import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layouts/mainIndex";
// 解决ElementUI导航栝中的vue-router在3.0版本以上針夝点蝜坕报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    title: "login",
    redirect: "/login",
    hidden: true,
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/",
    redirect: "/index",
    component: Layout,
    children: [
      {
        path: "/index",
        // title: "考试管理",
        title: "index",
        hidden: false,
        name: "index",
        component: () => import("@/views/examMgmt/examArrange/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          type: "1", //标识属于第几个头部菜单范围里的
          sideHidden: true, //判断不在侧边栏显示
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/index",
        // title: "考试安排",
        title: "examArrange",
        hidden: true,
        name: "examArrange",
        component: () => import("@/views/examMgmt/examArrange/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/index",
          type: "1",
          roles: ["admin", "examAdmin", "openTea"],
        },
      },
      {
        path: "/addArrange",
        title: "新增考试安排",
        hidden: true,
        name: "addArrange",
        component: () => import("@/views/examMgmt/examArrange/addArrange.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/index",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/selectExam",
        title: "选择考试",
        hidden: true,
        name: "selectExam",
        component: () => import("@/views/examMgmt/examLibrary/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/index",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examLibrary",
        // title: "考试库",
        title: "examLibrary",
        hidden: true,
        name: "examLibrary",
        component: () => import("@/views/examMgmt/examLibrary/mainIndex"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examLibrary",
          type: "1",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examLibrary/referencePaper",
        title: "引用试卷",
        hidden: true,
        name: "referencePaper",
        component: () =>
          import("@/views/examMgmt/examLibrary/referencePaper.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examLibrary",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examLibrary/examRegisterDetail",
        title: "考试注册",
        hidden: true,
        name: "examRegisterDetail",
        component: () =>
          import("@/views/examMgmt/examLibrary/examRegisterDetail.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examLibrary",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examLibrary/examAnalyse",
        title: "考试分析",
        hidden: true,
        name: "examAnalyse",
        component: () => import("@/views/examMgmt/examLibrary/examAnalyse.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examLibrary",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examLibrary/viewExam",
        title: "查看试卷",
        hidden: true,
        name: "viewExam",
        component: () => import("@/views/examMgmt/examLibrary/viewExam.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examLibrary",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examLibrary/examUserList",
        title: "应考名单",
        hidden: true,
        name: "examUserList",
        component: () =>
          import("@/views/examMgmt/examLibrary/examUserList.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/index",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examMgmt/addNewExam",
        title: "新增考试",
        hidden: true,
        name: "addNewExam",
        component: () => import("@/views/examMgmt/examLibrary/addNewExam.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examLibrary",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examRegister",
        title: "examRegister",
        // title: "考试注册",
        hidden: true,
        name: "examRegister",
        component: () => import("@/views/examMgmt/examRegister/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examRegister",
          type: "1",
          roles: ["admin", "examAdmin", "openTea", "gradeTea"],
        },
      },
      {
        path: "/registerDetail",
        title: "注册详情",
        hidden: true,
        name: "registerDetail",
        component: () =>
          import("@/views/examMgmt/examRegister/registerDetail.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examRegister",
          roles: ["admin", "examAdmin", "openTea", "gradeTea"],
        },
      },
      {
        path: "/registerOperate",
        title: "注册操作",
        hidden: true,
        name: "registerOperate",
        component: () =>
          import("@/views/examMgmt/examRegister/registerOperate.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examRegister",
          roles: ["admin", "examAdmin", "openTea", "gradeTea"],
        },
      },
      {
        path: "/examMonitor",
        title: "examMonitor",
        // title: "考试监控",
        hidden: true,
        name: "examMonitor",
        component: () => import("@/views/examMgmt/examMonitor/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examMonitor",
          type: "1",
          roles: ["admin", "examAdmin", "openTea"],
        },
      },
      {
        path: "/monitorDetail",
        title: "监控详情",
        hidden: true,
        name: "monitorDetail",
        component: () =>
          import("@/views/examMgmt/examMonitor/monitorDetail.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examMonitor",
          roles: ["admin", "examAdmin", "openTea"],
        },
      },
      {
        path: "/examMarking",
        title: "examMarking",
        // title: "考试阅卷",
        hidden: true,
        name: "examMarking",
        component: () => import("@/views/examMgmt/examMarking/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examMarking",
          type: "1",
          roles: ["admin", "examAdmin", "gradeTea"],
        },
      },
      {
        path: "/anExamMarking",
        title: "某考试阅卷",
        hidden: true,
        name: "anExamMarking",
        component: () =>
          import("@/views/examMgmt/examMarking/anExamMarking.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examMarking",
          roles: ["admin", "examAdmin", "gradeTea"],
        },
      },
      {
        path: "/examGrade",
        title: "examGrade",
        // title: "考试成绩",
        hidden: true,
        name: "examGrade",
        component: () => import("@/views/examMgmt/examGrade/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examGrade",
          type: "1",
          roles: ["admin", "examAdmin", "openTea"],
        },
      },
      {
        path: "/markingDetail",
        title: "考试成绩详情",
        hidden: true,
        name: "markingDetail",
        component: () =>
          import("@/views/examMgmt/examMarking/markingDetail.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examMarking",
          roles: ["admin", "examAdmin", "openTea"],
        },
      },
      {
        path: "/examGrade/perExamGrade",
        title: "单个考试成绩详情",
        hidden: true,
        name: "perExamGrade",
        component: () => import("@/views/examMgmt/examGrade/perExamGrade.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/examGrade",
          roles: ["admin", "examAdmin", "openTea"],
        },
      },
      {
        path: "/recycleBin",
        title: "recycleBin",
        // title: "回收站",
        hidden: true,
        name: "recycleBin",
        component: () => import("@/views/examMgmt/recycleBin/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/recycleBin",
          type: "1",
          roles: ["admin"],
        },
      },
      {
        path: "/qbankMgmt",
        // title: "题库管理",
        title: "qbankMgmt",
        hidden: false,
        name: "qbankMgmt",
        component: () =>
          import("@/views/questionBankMgmt/qbankMgmt/mainIndex.vue"),
        meta: {
          activeMenu: "/qbankMgmt",
          sideActiveMenu: "/qbankMgmt",
          type: "2",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/qbankAudit",
        title: "questionBankAudit",
        // title: "题库审核",

        hidden: true,
        name: "questionBankMgmt",
        component: () =>
          import("@/views/questionBankMgmt/qbankAudit/mainIndex.vue"),
        meta: {
          activeMenu: "/qbankMgmt",
          sideActiveMenu: "/qbankAudit",
          type: "2",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/singleChoice",
        title: "查看试题",
        hidden: true,
        name: "viewSingleChoise",
        component: () =>
          import("@/views/questionBankMgmt/checkQuestion/singleChoice.vue"),
        meta: {
          activeMenu: "/qbankMgmt",
          sideActiveMenu: "/qbankAudit",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/editSingleChoice",
        title: "编辑试题",
        hidden: true,
        name: "editSingleChoise",
        component: () =>
          import("@/views/questionBankMgmt/editQuestion/editSingleChoise.vue"),
        meta: {
          activeMenu: "/qbankMgmt",
          sideActiveMenu: "/qbankMgmt",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/qbankMgmt/classifyMgmt",
        title: "分类管理",
        hidden: true,
        name: "classifyMgmt",
        component: () =>
          import("@/views/questionBankMgmt/qbankMgmt/classifyMgmt.vue"),
        meta: {
          activeMenu: "/qbankMgmt",
          sideActiveMenu: "/qbankMgmt",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/qbankMgmt/importQuestion",
        title: "导入试题",
        hidden: true,
        name: "importQuestion",
        component: () =>
          import("@/views/questionBankMgmt/qbankMgmt/importQuestion.vue"),
        meta: {
          activeMenu: "/qbankMgmt",
          sideActiveMenu: "/qbankMgmt",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examPaperMgmt",
        // title: "试卷管理",
        title: "examPaperMgmt",
        hidden: false,
        name: "examPaperMgmt",
        component: () =>
          import("../views/examPaperMgmt/examPaperMain/mainIndex.vue"),
        meta: {
          activeMenu: "/examPaperMgmt",
          sideActiveMenu: "/examPaperMgmt",
          type: "3",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examPaperMgmt/addExamPaper",
        title: "添加试题",
        hidden: true,
        name: "addExamPaper",
        component: () =>
          import("../views/examPaperMgmt/examPaperMain/addExamPaper.vue"),
        meta: {
          activeMenu: "/examPaperMgmt",
          sideActiveMenu: "/examPaperMgmt",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/examPaperMgmt/randomQuestion",
        title: "随机抽题",
        hidden: true,
        name: "randomQuestion",
        component: () =>
          import("../views/examPaperMgmt/examPaperMain/randomQuestion.vue"),
        meta: {
          activeMenu: "/examPaperMgmt",
          sideActiveMenu: "/examPaperMgmt",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/paperPreview",
        title: "试卷预览",
        hidden: true,
        name: "paperPreview",
        component: () =>
          import("@/views/examPaperMgmt/examPaperMain/paperPreview.vue"),
        meta: {
          activeMenu: "/examPaperMgmt",
          sideActiveMenu: "/examPaperMgmt",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/ePAuditMgmt",
        title: "ePAuditMgmt",
        // title: "试卷审核",
        hidden: true,
        name: "ePAuditMgmt",
        component: () =>
          import("../views/examPaperMgmt/ePAuditMgmt/mainIndex.vue"),
        meta: {
          activeMenu: "/examPaperMgmt",
          sideActiveMenu: "/ePAuditMgmt",
          type: "3",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/auditPreview",
        title: "审核预览",
        hidden: true,
        name: "auditPreview",
        component: () =>
          import("@/views/examPaperMgmt/ePAuditMgmt/paperPreview.vue"),
        meta: {
          activeMenu: "/examPaperMgmt",
          sideActiveMenu: "/ePAuditMgmt",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/operateLog",
        // title: "操作日志",
        title: "operateLog",
        hidden: false,
        name: "operateLog",
        component: () => import("../views/operateLog/mainIndex.vue"),
        meta: {
          activeMenu: "/operateLog",
          sideActiveMenu: "/operateLog",
          type: "4",
          roles: ["admin", "examAdmin"],
        },
      },
      {
        path: "/sysSituation",
        // title: "系统概况",
        title: "sysSituation",
        hidden: false,
        name: "sysSituation",
        component: () => import("../views/sysSituation/mainIndex.vue"),
        meta: {
          activeMenu: "/sysSituation",
          sideActiveMenu: "/sysSituation",
          type: "5",
          roles: ["admin", "examAdmin"],
        },
      },

      //学员端
      {
        path: "/myExams",
        // title: "我的考试",
        title: "myExams",
        hidden: true,
        name: "myExams",
        component: () => import("../views/student/exam/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/myExams",
          type: "1",
          roles: ["stu"],
        },
      },
      {
        path: "/examInstruction",
        title: "考试须知",
        hidden: true,
        name: "examInstruction",
        component: () => import("../views/student/exam/examInstruction.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/myExams",
          roles: ["stu"],
        },
      },
      {
        path: "/takingExam",
        title: "考试中",
        hidden: true,
        name: "takingExam",
        component: () => import("../views/student/exam/takingExam.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/myExams",
          roles: ["stu"],
        },
      },
      {
        path: "/myScore",
        title: "myScore",
        hidden: true,
        name: "myScore",
        component: () => import("../views/student/score/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/myScore",
          type: "1",
          roles: ["stu"],
        },
      },
      {
        path: "/scoreDetail",
        title: "答题详情",
        hidden: true,
        name: "scoreDetail",
        component: () => import("../views/student/score/scoreDetail.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/myScore",
          roles: ["stu"],
        },
      },
      {
        path: "/wrongCollect",
        title: "wrongCollect",
        hidden: true,
        name: "wrongCollect",
        component: () => import("../views/student/wrongCollect/mainIndex.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/wrongCollect",
          type: "1",
          roles: ["stu"],
        },
      },
      {
        path: "/wrongDetail",
        title: "错题详情",
        hidden: true,
        name: "wrongDetail",
        component: () =>
          import("../views/student/wrongCollect/wrongDetail.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/wrongCollect",
          roles: ["stu"],
        },
      },
      {
        path: "/retrainWrong",
        title: "错题重练",
        hidden: true,
        name: "retrainWrong",
        component: () =>
          import("../views/student/wrongCollect/retrainWrong.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/wrongCollect",
          roles: ["stu"],
        },
      },
      {
        path: "/inRetraining",
        title: "重练中",
        hidden: true,
        name: "inRetraining",
        component: () =>
          import("../views/student/wrongCollect/inRetraining.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/wrongCollect",
          roles: ["stu"],
        },
      },
      {
        path: "/retrainResult",
        title: "错题重练结果",
        hidden: true,
        name: "retrainResult",
        component: () =>
          import("../views/student/wrongCollect/retrainResult.vue"),
        meta: {
          activeMenu: "/index",
          sideActiveMenu: "/wrongCollect",
          roles: ["stu"],
        },
      },
    ],
  },
  {
    path: "/401",
    name: "401",
    component: () => import("@/views/401"),
    hidden: true,
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404"),
    hidden: true,
  },
];

// 动态路由
export const DynamicRoutes = [];

const router = new VueRouter({
  routes,
});

export default router;
